export default {
    namespaced: true,

    state: () => ({
        mobileMenuOpen: false,
        lightboxOpen: false,
        lightboxImage: null,
        lightboxTitle: '',
        headerTransparent: true,
        activeNavItem: null,
    }),

    mutations: {
        SET_MOBILE_MENU(state, val) { state.mobileMenuOpen = val },
        TOGGLE_MOBILE_MENU(state) { state.mobileMenuOpen = !state.mobileMenuOpen },
        SET_LIGHTBOX(state, { open, image, title }) {
            state.lightboxOpen = open
            if (image !== undefined) state.lightboxImage = image
            if (title !== undefined) state.lightboxTitle = title
        },
        SET_HEADER_TRANSPARENT(state, val) { state.headerTransparent = val },
        SET_ACTIVE_NAV(state, val) { state.activeNavItem = val },
    },

    actions: {
        openLightbox({ commit }, { image, title }) {
            commit('SET_LIGHTBOX', { open: true, image, title })
            document.body.style.overflow = 'hidden'
        },
        closeLightbox({ commit }) {
            commit('SET_LIGHTBOX', { open: false })
            document.body.style.overflow = ''
        },
    }
}
